import { legacyPlugins } from "/app/node_modules/.bun/@unhead+vue@3.4.3+724a2a2a8f97da1d/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}